import { AxiosResponse } from 'axios';
import { AxiosConfig, axiosErrorExceptionAsync, AxiosRequest } from '../axios.config';
import { fromByteArray } from 'base64-js';
import { IDashboardDataListItem } from './dashboard.api';
export type GetReportParamRequest = {
  type: string;
};

export type GetResponse = {
  messageList: any[];
  vocList: any[];
};

export interface IReportPageDetailData {
  dataList: IDashboardDataListItem[];
}

// ── report-pdf(클라이언트 PDF 생성)용: chc-admin-web 리포트 조회 응답과 동일한 구조 ──
export interface IReportPdfSurveyInfoItem {
  colorCd: 'GREEN' | 'ORANGE' | 'RED';
  mnmtToolNm: string;
  graphNm: string;
  graphItemNm?: string;
  userType?: string;
}

export interface IReportPdfSurveySection {
  name: string;
  data: IDashboardDataListItem[];
}

export interface IReportPdfPerson {
  survey: IReportPdfSurveySection[];
  surveyInfo: IReportPdfSurveyInfoItem[];
  name: string;
  age: number;
  birth: string;
  gender: string;
  surveyTime?: number;
}

export interface IReportPdfData {
  patnt?: IReportPdfPerson; // 환아
  parnt?: IReportPdfPerson; // 보호자
}

export class ReportAPI extends AxiosConfig {
  private _prefix = '/v1';
  private _url = `${this._prefix}/report`;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(useBaseURL?: boolean, token?: string, device?: string) {
    super(useBaseURL, token, device);
  }

  /**
   * 09. 리포트 API - 측정도구 목록 조회
   * @see https://chc-app-api.huraydev.net/swagger-ui/index.html
   * @version 1.0.0
   */
  public getSurveysAsync = async (): Promise<AxiosResponse<any> | AxiosResponse<unknown, any>> => {
    try {
      return await this.instance.get<any>(`${this._url}/surveys`);
    } catch (error) {
      return axiosErrorExceptionAsync(error);
    }
  };

  /**
   * 09. 리포트 API - 리포트 상세 조회
   * @see https://chc-app-api.huraydev.net/swagger-ui/index.html
   * @version 1.0.0
   */
  public getDetailAsync = async ({ type }: AxiosRequest<any>): Promise<AxiosResponse<IReportPageDetailData>> => {
    return await this.instance.get<IReportPageDetailData>(`${this._url}/detail/${type}`);
  };

  /**
   *
   * 09. 리포트 API - 리포트 PDF 생성
   */
  public getReportPDF = async (): Promise<string> => {
    try {
      const response = await this.instance.get<any>(`${this._url}/pdf`, { responseType: 'arraybuffer' });
      // console.log(response.data, '--> resp data');
      const base64File = fromByteArray(new Uint8Array(response.data));
      // console.log(base64File, 'base64File');
      return base64File;
    } catch (error) {
      console.error(error);
      return ''; // 기본적으로 빈 문자열을 반환합니다.
    }
  };

  /**
   * 09. 리포트 API - 리포트 PDF 생성용 데이터 조회
   * chc-admin-web 리포트 조회와 동일한 구조({ dataList: { patnt, parnt } })로 내려온다.
   * 클라이언트(report-part-body-parse.view.tsx)에서 jsPDF 로 PDF 를 직접 생성한다.
   */
  public getReportPDFData = async (): Promise<IReportPdfData | null> => {
    try {
      const response = await this.instance.get<{ dataList: IReportPdfData }>(`${this._url}`);
      return response.data?.dataList ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
}
